<template>
  <a-form
    layout="inline"
    :model="formState"
    style="margin-bottom: 10px; padding-right: 65px; position: relative"
    ref="formRef"
  >
    <template v-for="item in props.collection" :key="item.field">
      <a-form-item :label="item.label" style="margin-bottom: 10px" v-if="!item.hidden">
        <template v-if="item.type === 'input'">
          <Input v-bind="item" v-model="formState[item.field]" />
        </template>
        <template v-if="item.type === 'inputNumber'">
          <InputNumber v-bind="item" v-model="formState[item.field]" />
        </template>
        <template v-if="item.type === 'select'">
          <Select
            v-bind="item"
            v-model="formState[item.field]"
            :options="item.options || getOption(item)"
            :onChange="selectChange"
          />
        </template>
        <template v-if="item.type === 'date'">
          <DatePicker v-bind="item" v-model="formState[item.field]" :allowClear="item.allowClear" />
        </template>
        <template v-if="item.type === 'dateRange'">
          <DateRange
            v-bind="item"
            v-model:start="formState[item.startField]"
            v-model:end="formState[item.endField]"
            :allowClear="item.allowClear"
          />
        </template>
      </a-form-item>
    </template>
    <a-form-item>
      <a-button v-if="props.ableReset && resetWillRequest" @click="resetFormAndRequest">重置</a-button>
      <a-button v-else-if="props.ableReset && !resetWillRequest" @click="resetForm">重置</a-button>
      &nbsp;
      <a-button v-if="props.ableSearch" type="primary" @click="props.handelSearch">查询</a-button>
    </a-form-item>
    <a-form-item>
      <slot>
        <a-button
          v-if="ableAdd && props.addBtn"
          type="primary"
          @click="props.handelAdd"
          :loading="props.addBtnLoading"
        >
          {{ props.addText }}
        </a-button>
      </slot>
    </a-form-item>
  </a-form>
</template>

<script setup>
  import {
    reactive,
    defineProps,
    defineEmits,
    defineExpose,
    toRefs,
    ref,
  } from 'vue'
  import Input from '@/components/form/input'
  import InputNumber from '@/components/form/input_number'
  import Select from '@/components/form/select'
  import { useStore } from 'vuex'
  import DateRange from '@/components/form/date_range'
  import { constantToOptions } from '@/utils/format'
  import DatePicker from '@/components/form/date'

  //初始化
  const props = defineProps({
    collection: Array,
    fetchData: Function,
    handelSearch: Function,
    handelAdd: Function,
    addBtn: { default: true, type: Boolean },
    addText: { default: '新增' },
    addBtnLoading: { default: false },
    ableSearch: { default: false },
    resetWillRequest: { default: false },  // 点击重置是否重新请求数据
    ableAdd: { default: false },
    ableReset: { default: true },
  })
  const formRef = ref()
  const emit = defineEmits()
  const formState = reactive(getDefaultState(props.collection))

  function selectChange(value) {
    emit('onChange', value)
  }

  function getDefaultState(collection) {
    const defaultState = {}
    collection.forEach((item) => {
      //处理特殊情况
      if (item.type === 'dateRange') {
        defaultState[item.startField] = item.defaultStart
        defaultState[item.endField] = item.defaultEnd
      } else if (item.type === 'addressPicker') {
        defaultState[item.latField] = item.defaultLat
        defaultState[item.lngField] = item.defaultLng
      } else if (item.type === 'radio' || item.type === 'select') {
        //value转字符串
        defaultState[item.field] =
          item.defaultValue !== undefined ? item.defaultValue + '' : ''
      } else {
        //正常情况
        defaultState[item.field] = item.defaultValue || ''
      }
    })
    return defaultState
  }

  defineExpose({
    formState,
  })

  //获取store中的option数据
  const store = useStore()
  const Enum = toRefs(store.state?.common)
  function getOption({
    storeOptions,
    getName = false,
    filterNegative = false,
  } = {}) {
    if (Enum[storeOptions])
      return constantToOptions(Enum[storeOptions].value, {
        filterNegative,
        getName,
      })
    else return []
  }

  function resetForm() {
    formRef.value.resetFields()
    resetFormState(props.collection, formState)
  }

  function resetFormAndRequest() {
    formRef.value.resetFields()
    resetFormState(props.collection, formState)
    emit('reset')
  }

  function resetFormState(collection) {
    for (let item of collection) {
      //处理特殊情况
      if (item.type === 'dateRange') {
        formState[item.startField] = item.defaultStart
        formState[item.endField] = item.defaultEnd
      } else if (item.type === 'addressPicker') {
        formState[item.latField] = item.defaultLat
        formState[item.lngField] = item.defaultLng
      } else if (item.type === 'radio' || item.type === 'select') {
        //value转字符串
        formState[item.field] =
          item.defaultValue !== undefined ? item.defaultValue + '' : ''
      } else {
        //正常情况
        formState[item.field] = item.defaultValue || ''
      }
    }
  }
</script>

<style lang="less" scoped></style>
